export function PDeleteWarnLiterals(t: any) {
    return {
        title:  t("deleteWarnLiterals.title"),
        item1: t("deleteWarnLiterals.item1"),
        item2: t("deleteWarnLiterals.item2"),
        item3: t("deleteWarnLiterals.item3"),
        button: t("deleteWarnLiterals.button"),
    }
}

export function PDeleteConfirmLiterals(t: any) {
    return {
        title: t("PDeleteConfirmLiterals.title"),
        desc1: t("PDeleteConfirmLiterals.desc1"),
        desc2: t("PDeleteConfirmLiterals.desc2"),
        desc3: t("PDeleteConfirmLiterals.desc3"),
        desc4: t("PDeleteConfirmLiterals.desc4"),
        button: t("PDeleteConfirmLiterals.button"),
    }
}